import { Box } from '@chakra-ui/react';
import { V2QSFlow } from 'components/v2qs';

export function V2QSScreen() {
  return (
    <Box position="relative" minH="100vh" bg="white">
      <V2QSFlow />
    </Box>
  );
}
